import { render } from "./TimeRecordList.vue?vue&type=template&id=25ed5a28"
import script from "./TimeRecordList.vue?vue&type=script&lang=js"
export * from "./TimeRecordList.vue?vue&type=script&lang=js"
script.render = render

export default script